var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEckoLogoLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-logo-loader-1",
    x1: -0.028,
    y1: -0.028,
    x2: 0.859,
    y2: 0.859,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff00b8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_113101",
    "data-name": "Group 113101",
    transform: "translate(-1460.8 13719.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143825",
    "data-name": "Path 143825",
    d: "M-1040.346,7044.379a16.018,16.018,0,0,1-16-16,16.018,16.018,0,0,1,16-16,16.018,16.018,0,0,1,16,16A16.018,16.018,0,0,1-1040.346,7044.379Zm0-30.487a14.5,14.5,0,0,0-14.486,14.487,14.5,14.5,0,0,0,14.486,14.486,14.5,14.5,0,0,0,14.486-14.486A14.5,14.5,0,0,0-1040.346,7013.892Z",
    transform: "translate(2517.146 -20731.58)",
    fill: "url(#linear-gradient-logo-loader-1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143826",
    "data-name": "Path 143826",
    d: "M-1515.856,6459.847l-.905-.906-2-2,2-2,.905-.9.905.9,2,2-2,2Zm0,2.8v5.969l-8.687-8.687,2.985-2.983Zm-8.687-8.685v5.966l2.985-2.983,5.7-5.7v-5.969Z",
    transform: "translate(2995.453 -20160.09)",
    fill: "url(#linear-gradient-logo-loader-1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEckoLogoLoader);
export default __webpack_public_path__ + "static/media/ecko-logo-loader.89a43d5bc532068aa5467149f0e88045.svg";
export { ForwardRef as ReactComponent };